import { conf as preprodConf } from '@config/preprod'
import { conf as prodConf } from '@config/prod'
import type { Config } from '@config/prod'
import { conf as qaConf } from '@config/qa'

import { APP_ENV } from '@constants/globals'

const config = APP_ENV === 'prod' ? prodConf : APP_ENV === 'preprod' ? preprodConf : qaConf

export const getConfig = (): Config => {
  return config
}
